import React, { useState, useEffect } from "react";
import SideBar from "../../../../components/SideBar";
import Navbar from "../../../../components/Navbar";
import { API_URL } from "../../../../constants";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";
import { Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { components } from "react-select";


const Edit_PR_Appraisal = () => {
  const initialFormData = {
    Name: "",
    Code: "",
    Description: "",
    FromDate: null,
    ToDate: null,
    ID: "",
    AppraisalCycleProcessType: "",
    selectedOption: null,
    AppraisalCycleType: '',
    Active: 0,
    checkedItems: [],

    lines: [
      { LineNo: 1, ACID: "", AppraisalTemplateMasterID: "", EmployeeID: "" },
    ],
  };

  const navigate = useNavigate();
  const { id } = useParams();

  const [EmployeeListdata, setEmployeeListdata] = useState([]);
  const [templateOption, setTemplateOption] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData::::", formData);

  const [appraisalCycleTypeOption, setAppraisalCycleTypeOption] = useState([])


  const dispatch = useDispatch()
  useEffect(() => {
    fetchAppraisal();
    dispatch(updateNavbarHeading("PR Appraisal Cycle"))
  }, []);
  const fetchAppraisal = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}appraisal-cycles`);

      const employeeData = response?.data?.data?.employee_list;
      const newEmployeeListData = [
        { value: '', label: "Select ALL" },
        ...employeeData.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }))
      ];

      setEmployeeListdata(newEmployeeListData);

      const templateOption = response?.data?.data?.template_list.map(
        (item) => ({
          value: item.value,
          label: item.text,
        })
      );
      setTemplateOption(templateOption);

      const appraisalCycleTypeOption = Object.entries(response?.data?.data?.appraisalCycleTypes || {}).map(
        ([key, value]) => ({
          value: parseInt(key, 10), // Convert key to number if needed
          label: value,
        })
      );

      setAppraisalCycleTypeOption(appraisalCycleTypeOption)

    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchAppraisalID(id);
    }
  }, [id]);



  const reverseTransformData = (apiData) => {
    // Convert object to array if needed
    const dataArray = Array.isArray(apiData) ? apiData : Object.values(apiData);

    // Group by AppraisalTemplateMasterID
    const groupedByTemplate = {};

    dataArray.forEach(item => {
      const templateId = item.AppraisalTemplateMasterID;

      if (!groupedByTemplate[templateId]) {
        groupedByTemplate[templateId] = {
          AppraisalTemplateMasterID: templateId,
          EmployeeID: [] // Temporary array to collect employee IDs
        };
      }

      // Add employee ID to the array (ensure it's a number)
      const employeeId = parseInt(item.EmployeeID);
      if (!isNaN(employeeId)) {
        groupedByTemplate[templateId].EmployeeID.push(employeeId);
      }
    });

    // Convert to array, join EmployeeIDs as comma-separated string, and add line numbers
    const result = Object.values(groupedByTemplate).map((item, index) => ({
      LineNo: index + 1,
      AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
      EmployeeID: item.EmployeeID.join(',') // Convert array to comma-separated string
    }));

    return result;
  };


  const fetchAppraisalID = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}appraisal-cycles/${id}`
      );
      const data = response?.data?.data || {}; // Provide default value if data is null or undefined
      const lineData = data?.appraisalcycledetails;

      setFormData({
        ID: data?.appraisalcycle?.ID,
        Name: data?.appraisalcycle?.Name || "", // Default to empty string if undefined
        Code: data?.appraisalcycle?.Code, // This is hardcoded to an empty string; you may want to revise this if necessary
        Description: data?.appraisalcycle?.Description || "",
        FromDate: data?.appraisalcycle?.FromDate || "",
        ToDate: data?.appraisalcycle?.ToDate || "",
        Active: data?.appraisalcycle?.Active || 0,
        AppraisalCycleProcessType:
          data?.appraisalcycle?.AppraisalCycleProcessType || "",
        AppraisalCycleType: data?.appraisalcycle?.AppraisalCycleType
          || null,

        lines: reverseTransformData(lineData.map((ele) => ({
          ACID: ele?.ACID || "",
          LineNo: ele?.LineNo || "",
          AppraisalTemplateMasterID: ele?.AppraisalTemplateMasterID || "",
          EmployeeID: ele?.EmployeeID || "",
        }))),
      });
      if (response.status === 200) {
        // Update form data
      } else {
        console.error("Job not found with ID:", id);
      }
    } catch (error) {
      console.error("Error fetching appraisal details:", error);
      // Add user notification for better UX if necessary, e.g., a toast message or alert
    }
  };


  const transformData = (inputData) => {
    let result = [];
    let lineNo = 1;

    inputData.forEach(item => {
      // Handle comma-separated EmployeeID values
      if (typeof item.EmployeeID === 'string' && item.EmployeeID.includes(',')) {
        const employeeIds = item.EmployeeID.split(',').map(id => parseInt(id.trim()));
        employeeIds.forEach(employeeId => {
          result.push({
            LineNo: lineNo++,
            AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
            EmployeeID: employeeId
          });
        });
      } else if (Array.isArray(item.EmployeeID)) {
        // Handle array EmployeeID values
        item.EmployeeID.forEach(employeeId => {
          result.push({
            LineNo: lineNo++,
            AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
            EmployeeID: employeeId
          });
        });
      } else {
        // Single EmployeeID
        result.push({
          LineNo: lineNo++,
          AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
          EmployeeID: item.EmployeeID
        });
      }
    });

    return result;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      // Validate the entire form data
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear errors before submission

      const AppraisalData = {
        Name: formData.Name,
        AppraisalCycleProcessType: formData.AppraisalCycleProcessType,
        Code: formData.Code, // Static code transfer
        Description: formData.Description,
        FromDate: formData.FromDate,
        ToDate: formData.ToDate,
        Active: formData.Active,
        AppraisalCycleType: formData.AppraisalCycleType,
        // Active: 0,
        lines: transformData(formData.lines),
      };

      const response = await PostServiceCaller(
        `${API_URL}appraisal-cycles/${id}`,
        AppraisalData, // Use AppraisalData here
        "put"
      );

      if (response.status === 200) {
        // Successful response
        toast.success("PR Appraisal Cycle created successfully!");
        // toast.success("Data submitted successfully");
        setTimeout(() => {
          navigate("/appraisal-cycles")
        }, 2000);
      } else {
        // Handle non-200 status codes
        toast.error("PR Appraisal Cycle not created!");
      }
    } catch (error) {
      // Handle validation errors and other issues
      if (error.name === "ValidationError") {
        error.inner.forEach((e) => {
          setErrors((prev) => ({ ...prev, [e.path]: e.message }));
        });
      } else {
        console.error("Error:", error);
        toast.error("Sorry, there was an issue with your request.");
      }
    } finally {
      setLoading(false); // Ensure loading is stopped in both success and failure
    }
  };

  const schema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
    FromDate: Yup.date().required("FromDate is required"),
    ToDate: Yup.date().required("ToDate is required"),
    AppraisalCycleType: Yup.number().typeError("Appraisal Cycle Type is required").required('Appraisal Cycle Type is required').nullable(),

  });

  // Validate individual fields
  const validateField = async (name, value) => {
    try {
      await schema.validateAt(name, { ...formData, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: "" }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [name]: err.message }));
    }
  };

  const handleFormChange = async (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate only the changed field
    await validateField(name, value);
  };

  const handleAppraisalLineSelectChange = (option, name, index) => {
    const updatedLines = formData.lines.map((item, idx) =>
      idx === index ? { ...item, [name]: option.value } : item
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));
  };

  const handleAddAppraisalLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];
    if (currentRow && currentRow.AppraisalTemplateMasterID === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        {
          LineNo: formData.lines.length + 1,
          AppraisalTemplateMasterID: "",
          EmployeeID: "",
        },
      ],
    }));
  };





  const handleSelect = async (e, name) => {
    const value = e.value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Update formData with the selected value
    }));
    // Optional: Handle errors if no value is selected
    if (!value) {
      setErrors((errors) => ({
        ...errors,
        [name]: "This field must be selected.",
      }));
    }
    await validateField(name, value);
  };



  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [indexx, setIndexx] = useState("")

  const handleDeleteAppraisalLine = (index, item) => {

    setShowDeleteModal(true);
    setIndexx(index)
    setSelectedDeleteItem(item);


  };

  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      handleDeleteRequest(indexx, selectedDeleteItem.LineNo, selectedDeleteItem.ACID);

      setShowDeleteModal(false);
      setSelectedDeleteItem(null);

    }
  };
  const handleDeleteRequest = async (indexx, LineNo, ACID) => {
    try {
      await PostServiceCaller(
        `${API_URL}appraisal-cycles-remove-line`,
        {
          ID: ACID,
          LineNo: LineNo,
        },
        "post"
      );

      const updatedLines = formData.lines.filter((_, idx) => idx !== indexx);
      setFormData((prevFormData) => ({
        ...prevFormData,
        lines: updatedLines,
      }));
    } catch (error) {
      console.error("There was an error deleting the line!", error);
    }
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };


  const handleAppraisalLineSelectChangeEmp = (option, name, index) => {
    console.log("Handler received:", option, name, index);

    // Ensure proper clearing - if option is empty string, set it as empty string
    const cleanValue = (option === "" || option === null || option === undefined || option === "0") ? "" : option;

    const updatedLines = formData.lines.map((item, idx) =>
      idx === index ? { ...item, [name]: cleanValue } : item
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));

    console.log("Updated form data:", updatedLines);
  };


  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            backgroundColor: props.isSelected ? "#27568c" : "transparent",
            color: props.isSelected ? "#ffffff" : "#000000",

            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            className="me-2"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label>{props.label}</label>
        </div>
      </components.Option>
    );
  };
  return (
    <>

      <div className="Container">
        <form
          // onSubmit={handleSubmit}
          id="formOne"
          className="rounded bg-white  mt-3 px-3 pt-3"
        >
          <div className="row">
            <div className="col-4">
              <div className="col-12">
                <label htmlFor="Code" className="col-form-label">
                  <strong>Code</strong>
                </label>
              </div>
              <div className="col-12">
                <input
                  type="text"
                  id="Code"
                  className="form-control"
                  aria-describedby="Code"
                  value={formData.Code} // Ensure Code is controlled
                  disabled
                />
              </div>
            </div>
            <div className="col-4">
              <div className="col-12">
                <label htmlFor="Name" className="col-form-label">
                  <strong>Name<span className="required">*</span></strong>
                </label>
              </div>
              <div className="col-12">
                <input
                  type="text"
                  id="Name"
                  className={`form-control ${errors.Name ? "is-invalid" : ""
                    }`}
                  aria-describedby="Name"
                  value={formData.Name}
                  name="Name"
                  onChange={handleFormChange}
                />
                {errors.Name && (
                  <div className="invalid-feedback">{errors.Name}</div>
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="col-12">
                <label htmlFor="Description" className="col-form-label">
                  <strong>Description</strong>
                </label>
              </div>
              <div className="col-12">
                <input
                  type="text"
                  id="Description"
                  className="form-control"
                  name="Description"
                  aria-describedby="Description"
                  value={formData.Description}
                  onChange={handleFormChange}
                />
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-4">
              <label htmlFor="FromDate" className="col-form-label">
                <strong>From Date<span className="required">*</span></strong>
              </label>

              <CustomDatePicker
                name="FromDate"
                handleChange={handleFormChange}
                className={`form-control ${errors.FromDate ? "is-invalid" : ""
                  }`}
                value={formData.FromDate}
              />
              <div>
                {errors.FromDate && (
                  <div className="invalid-feedback">
                    {errors.FromDate}{" "}
                    {/* Directly display the error message */}
                  </div>
                )}
              </div>
            </div>
            <div className="col-4">
              <label htmlFor="ToDate" className="col-form-label">
                <strong>To Date<span className="required">*</span></strong>
              </label>

              <CustomDatePicker
                name="ToDate"
                handleChange={handleFormChange}
                className={`form-control ${errors.ToDate ? "is-invalid" : ""
                  }`}
                value={formData.ToDate}
              />

              {errors.ToDate && (
                <div className="invalid-feedback">{errors.ToDate}</div>
              )}
            </div>
            <div className="col-2 mt-4 pt-1 d-flex">
              <div>
                <input
                  className="me-2 form-check-input"
                  type="checkbox"
                  name="Active"
                  id="flexSwitchCheckChecked"
                  checked={formData.Active === 1}
                  onChange={(e) =>
                    handleFormChange({
                      target: {
                        name: e.target.name,
                        value: e.target.checked ? 1 : 0,
                      },
                    })
                  }
                />
              </div>              <label className="form-label">Active</label>

            </div>
            <div className="col-2 mt-4 ">
              <label className="col-form-label">
                <strong>Appraisal Type<span className="required">*</span></strong>
              </label>

              <div className="ms-2">
                <input
                  type="radio"
                  className="form-check-input me-2"
                  checked={formData.AppraisalCycleProcessType === "old"}
                  name="AppraisalCycleProcessType"
                  onChange={handleFormChange}
                  value="old"
                />
                <span className="me-2">Old</span>
                <input
                  type="radio"
                  checked={formData.AppraisalCycleProcessType === "new"}
                  className="form-check-input me-2"
                  name="AppraisalCycleProcessType" // Removed extra space before name
                  onChange={handleFormChange}
                  value="new"
                />
                <span>New</span>
              </div>
            </div>

          </div>
          <div className="row mb-2">
            {formData?.AppraisalCycleProcessType !== "old" && (
              <div className="col-4">
                <label className="form-label">
                  <strong>Appraisal Cycle Type</strong>
                </label>
                <Select
                  name="AppraisalCycleType"
                  onChange={(e, action) => handleSelect(e, action.name)}
                  value={
                    formData.AppraisalCycleType == null
                      ? ""
                      : appraisalCycleTypeOption.find(
                        (o) => o.value == formData.AppraisalCycleType
                      )
                  }
                  className={errors.AppraisalCycleType ? "is-invalid" : ""}
                  options={appraisalCycleTypeOption}
                />
                <span className="error">{errors?.AppraisalCycleType}</span>
              </div>
            )}
          </div>

          {/* Assign Template */}
          <div className="mt-2">
            <div className="mt-3">
              <h4>Assign Template</h4>
            </div>

            <div className="table-responsive poc-head rounded mt-2">
              <button
                type="button"
                onClick={handleAddAppraisalLine}
                className="custom-btn mb-2 pull-right "
              >
                <i className="fa fa-plus"></i>&nbsp;Add
              </button>
              <Table
                style={{ background: "#ECECEC !important" }}
                className="table table-bordered"
              >
                <thead id="thcolor" className="text-center align-middle">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Template</th>
                    <th>Employee</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="text-center align-middle">
                  {formData.lines.map((tempLine, index) => (
                    <tr key={tempLine.id || index}>
                      <td>{index + 1}</td>
                      <td>
                        <Select
                          options={templateOption}
                          value={templateOption.find(
                            (option) =>
                              option.value ==
                              tempLine.AppraisalTemplateMasterID
                          )}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 1050,
                            }),
                          }}
                          onChange={(selectedOption) =>
                            handleAppraisalLineSelectChange(
                              selectedOption,
                              "AppraisalTemplateMasterID",
                              index
                            )
                          }
                          placeholder="Select Question"
                        />
                      </td>
                      <td style={{ width: "40%" }}>
                        <Select
                          options={EmployeeListdata}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          value={
                            (() => {
                              if (tempLine.EmployeeID && tempLine.EmployeeID !== "") {
                                const selectedValues = tempLine.EmployeeID.split(",");

                                const allEmployeeValues = EmployeeListdata
                                  .filter(opt => opt.value !== "")
                                  .map(opt => opt.value.toString());

                                const allSelected = allEmployeeValues.length > 0 &&
                                  allEmployeeValues.every(v => selectedValues.includes(v));

                                // If all employees selected, also include "Select ALL"
                                return EmployeeListdata.filter(
                                  opt => opt.value !== "" && selectedValues.includes(opt.value.toString())
                                ).concat(allSelected ? [EmployeeListdata.find(opt => opt.value === "")] : []);
                              }
                              return [];
                            })()
                          }
                          components={{ Option }}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          styles={{
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected ? "#27568c" : "transparent",
                              color: state.isSelected ? "#ffffff" : "#000000",
                              '&:hover': {
                                backgroundColor: "#e6f0fa",
                              },
                            }),
                            container: (base) => ({
                              ...base,
                              width: "100%",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "300px",
                              overflowY: "auto",
                            }),
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(selected, actionMeta) => {
                            let newValue = "";

                            if (actionMeta.action === 'select-option' && actionMeta.option?.value === "") {
                              // Select ALL
                              const allEmployees = EmployeeListdata.filter(emp => emp.value !== "");
                              newValue = allEmployees.map(emp => emp.value).join(",");
                            }
                            else if ((actionMeta.action === 'remove-value' && actionMeta.removedValue?.value === "") ||
                              (actionMeta.action === 'deselect-option' && actionMeta.option?.value === "") ||
                              selected === null) {
                              // Clear ALL
                              newValue = "";
                            }
                            else {
                              // Normal selection
                              const filteredSelected = selected ? selected.filter(item => item.value !== "") : [];
                              newValue = filteredSelected.map(item => item.value).join(",");
                            }

                            handleAppraisalLineSelectChangeEmp(newValue, "EmployeeID", index);
                          }}
                          placeholder="Select Employee"
                        />
                      </td>
                      <td className="text-center align-middle">
                        <div
                          role="button" // Changed type to role for accessibility
                          onClick={() =>
                            handleDeleteAppraisalLine(index, tempLine)
                          }
                        >
                          <i
                            className="bi bi-trash"
                            style={{ fontSize: "1.2rem" }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="text-end mb-2">
            <button
              type="button"
              className="cancel-btn mt-3 me-2"
              onClick={() => navigate(`/appraisal-cycles`)}
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={loading}
              className="custom-btn me-2"
              onClick={handleSubmit}
            >
              {loading ? <FaSpinner className="sm-spinner" /> : "Submit"}
            </button>
          </div>
        </form>

        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete this item?"
        />
      </div>

    </>
  );
};

export default Edit_PR_Appraisal;
